<script setup lang="ts">
  import { inject, onMounted, useTemplateRef } from 'vue'
  import { accessRoleDetailKey } from '@gat-ship/types/injection-keys'
  import { useAccessRoleDetail } from '../../composables/useAccessRoleDetail'
  import AccessRoleModalChangeName from '../modals/AccessRoleModalChangeName.vue'
  import AccessRoleAlertDialogDelete from '../modals/AccessRoleAlertDialogDelete.vue'
  import {
    provideAccessRoleDetail,
    type ShowChangeAccessRoleNameDialogParams,
    type ShowDeleteAccessRoleDialogParams
  } from './access-role-detail-context'
  import type { useAccessRolesCollectionProvider } from './access-roles-collection-context'

  const props = withDefaults(
    defineProps<{
      roleId: string
      fetchOnMount?: boolean
      accessRolesProvider?: ReturnType<typeof useAccessRolesCollectionProvider>
    }>(),
    {
      fetchOnMount: true
    }
  )

  const modalChangeAccessRoleNameRef = useTemplateRef(
    'modalChangeAccessRoleNameRef'
  )
  const alertDialogDeleteAccessRoleRef = useTemplateRef(
    'alertDialogDeleteAccessRoleRef'
  )

  const dataSource =
    inject(accessRoleDetailKey, undefined) ??
    useAccessRoleDetail(props.accessRolesProvider?.dataSource)

  onMounted(() => {
    if (props.fetchOnMount) {
      dataSource.fetchAccessRole(props.roleId)
    }
  })

  const providerContext = provideAccessRoleDetail({
    dataSource,
    modals: {
      showChangeAccessRoleName: (
        params: ShowChangeAccessRoleNameDialogParams
      ) => {
        modalChangeAccessRoleNameRef.value?.showModal(params)
      },
      showDeleteAccessRole: (params: ShowDeleteAccessRoleDialogParams) => {
        alertDialogDeleteAccessRoleRef.value?.showModal(params)
      }
    }
  })

  defineExpose(providerContext)
</script>

<template>
  <slot />
  <AccessRoleModalChangeName ref="modalChangeAccessRoleNameRef" />
  <AccessRoleAlertDialogDelete ref="alertDialogDeleteAccessRoleRef" />
</template>
